/**
 * Returns the date of the most recent Monday
 * @returns {Date} The date of the most recent Monday
 */
export const getMostRecentMonday = () => {
  const today = new Date();
  const day = today.getDay(); // 0 is Sunday, 1 is Monday, etc.
  
  // Calculate days to subtract to get to the most recent Monday
  // If today is Monday (1), subtract 0 days
  // If today is Tuesday (2), subtract 1 day, etc.
  // If today is Sunday (0), subtract 6 days
  const daysToSubtract = day === 0 ? 6 : day - 1;
  
  // Create a new date by subtracting the appropriate number of days
  const mostRecentMonday = new Date(today);
  mostRecentMonday.setDate(today.getDate() - daysToSubtract);
  
  // Reset the time to 00:00:00
  mostRecentMonday.setHours(0, 0, 0, 0);
  
  return mostRecentMonday;
};

/**
 * Formats a date in human-readable Spanish format (DD de Mes de YYYY)
 * @param {Date} date - The date to format
 * @returns {string} The formatted date string
 */
export const formatDateES = (date) => {
  const day = date.getDate();
  const monthNames = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  
  return `${day} de ${month} de ${year}`;
};

/**
 * Returns the current date and time in human-readable Spanish format
 * @returns {string} The current date and time
 */
export const getCurrentDateTime = () => {
  const now = new Date();
  const day = now.getDate();
  const monthNames = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];
  const month = monthNames[now.getMonth()];
  const year = now.getFullYear();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  
  return `${day} de ${month} de ${year}, ${hours}:${minutes}:${seconds}`;
};